<template>
  <div>
    <Doughnut
      :chartData="ChartData"
      :chart-options="chartOptions"
      :plugins="plugins" />
  </div>
</template>

<script>
import {
  Chart,
  registerables,
} from 'chart.js';
import { Doughnut } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { CHART_COLORS } from '@/constants/color';

Chart.register(...registerables);

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut,
  },
  props: {
    labelsData: { // 表の判例の情報
      type: Array,
      default: null,
    },
    datasetsData: { // グラフ描画用データ
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        cutout: '80%',
        plugins: {
          legend: {
            display: false,
            // position: 'bottom',
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const label = context.label;
                const value = context.parsed;
                return `${label}: ${value}`;
              },
            },
          },
          datalabels: {
            ...CHART_COLORS.pieLabels,
            formatter: (value, context) => {
              const dataset = context.chart.data.datasets[0];
              const total = dataset.data.reduce((acc, val) => acc + val, 0);

              // データがない場合は非表示
              if (!total || total === 0) {
                return null;
              }

              const percentage = Math.round((value / total) * 100);
              const label = context.chart.data.labels[context.dataIndex];

              // 5%未満: 非表示
              if (percentage < 5) {
                return null;
              }
              // 5-10%: パーセンテージのみ
              if (percentage < 10) {
                return `${percentage}%`;
              }
              // 10%以上: ラベル名 + パーセンテージ
              return `${label}\n${percentage}%`;
            },
            display: 'auto', // 重なったらベルを非表示にする（重なりの判定はデフォルトで行われる）
            anchor: 'end',
            align: 'start',
            offset: -10,
          },
        },
      },
      plugins: [ChartDataLabels],
    };
  },
  created() {},
  mounted() {
    this.drawGraph();
  },
  watch: {
    labelsData() { // 親コンポーネントでフィルターの条件を変更して再度描画する時用
      this.updateGraph();
    },
  },
  methods: {
    updateGraph() {
      this.ChartData.labels = [];
      this.ChartData.datasets = [];
      this.drawGraph();
    },
    drawGraph() {
      this.labelsData.forEach((elem) => {
        this.ChartData.labels.push(elem);
      });
      this.ChartData.datasets.push(this.datasetsData);
    },
  },
};
</script>
